import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const Loading = ({visible}) => {
  return (
    <div className='loading_bkg' style={visible ? {} : { display: 'none' }}>
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  )
}

export default Loading